// extracted by mini-css-extract-plugin
export var consentActions = "CookieConsentBanner-module--consent-actions--30fa8";
export var consentButton = "CookieConsentBanner-module--consent-button--ae345";
export var consentHeader = "CookieConsentBanner-module--consent-header--d578e";
export var consentTitle = "CookieConsentBanner-module--consent-title--b2c27";
export var cookieConsentBanner = "CookieConsentBanner-module--cookie-consent-banner--ee75e";
export var cookieConsentForm = "CookieConsentBanner-module--cookie-consent-form--d7c60";
export var cookiesInfo = "CookieConsentBanner-module--cookies-info--47a2d";
export var declineButton = "CookieConsentBanner-module--decline-button--d9b53";